export default "__VITE_ASSET__234fd7cd__"